import React, {useEffect, useState} from 'react'
import { toast } from 'react-toastify';
import { Container, Grid, Header, Icon, Loader, Segment, Image, Message, Modal, Button, Table, Dimmer, Divider, List } from 'semantic-ui-react';

const PartnerDetailPage = (props) =>{
    const [partnerData, setPartnerData] = useState(null)
    const [leaderboard, setLeaderboard] = useState([])
    const [summary, setSummary] = useState([])
    const [improvement, setImprovement] = useState([])
    const [loading, setLoading] = useState(true)
    useEffect(()=>{
        window.scrollTo(0, 0);
        setPartnerData(props.data)
        loadData(props.data)
    }, [props.data]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadData = (param) =>{
        let parameters = {
            challenge_id: param.Record_KEY,
            la_code: param.LA_Code,
            type: param.Leaderboard_Type,
            time_start: param.Time_Start,
            time_end: param.Time_End
        }

        if(param.Sections.includes('improvement') || param.Leaderboard_Type.includes('Learning improvement')){
            parameters.improvement = 1
        }
        if(param.Sections.includes('summary')){
            let settings = JSON.parse(param.Settings)
            parameters.number_of_winner = settings.number_of_winner
            parameters.minimum_requirement = settings.minimum_requirement
        }
        setLoading(true)
        fetch(process.env.REACT_APP_BACKENDPORTAL_URL+'challenge/getLeaderboard', {
            method: 'post',
            body: JSON.stringify(parameters),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            if(res.status === 200 || res.status === 404){
                setLeaderboard(res.data)
                setSummary(res.summary === undefined ? [] : res.summary)
                setImprovement(res.improvement === undefined ? [] : res.improvement)
            }

            setLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong fetching partner leaderboard data, please contact the developer!')
        })
    }

    const generateLeaderboard = (is_mission, type) =>{
        let components = null
        let wordNumber = partnerData.Leaderboard_Type.includes('Star') ? 'star(s)' : ''
        if(type === 'group' || type === 'alliance'){
            if(is_mission){
                if(type === 'alliance'){
                    components = <table className="ui celled structured table">
                    <thead>
                      <tr>
                        <th rowSpan="2">Rank</th>
                        <th rowSpan="2">Alliance Name</th>
                        <th rowSpan="2">Leader</th>
                        <th rowSpan="2">Alliance Level</th>
                        <th colSpan="3" className="center aligned">Mission Completed</th>
                      </tr>
                      <tr>
                        <th>Daily</th>
                        <th>Weekly</th>
                        <th>Monthly</th>
                      </tr>
                    </thead>
                    <Table.Body>
                        {leaderboard.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.alliance_name}</Table.Cell>
                            <Table.Cell>{v.leader_mayor_name} ({v.leader_city_name})</Table.Cell>
                            <Table.Cell>{v.alliance_level}</Table.Cell>
                            <Table.Cell>{v.daily}</Table.Cell>
                            <Table.Cell>{v.weekly}</Table.Cell>
                            <Table.Cell>{v.monthly}</Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                    </table>
                }else{
                    components = <table className="ui celled structured table">
                    <thead>
                      <tr>
                        <th rowSpan="2">Rank</th>
                        <th rowSpan="2">Group Name</th>
                        <th rowSpan="2">Teacher</th>
                        <th colSpan="3" className="center aligned">Mission Completed</th>
                      </tr>
                      <tr>
                        <th>Daily</th>
                        <th>Weekly</th>
                        <th>Monthly</th>
                      </tr>
                    </thead>
                    <Table.Body>
                        {leaderboard.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.group_name}</Table.Cell>
                            <Table.Cell>{v.teacher_first_name} {v.teacher_last_name}</Table.Cell>
                            <Table.Cell>{v.daily}</Table.Cell>
                            <Table.Cell>{v.weekly}</Table.Cell>
                            <Table.Cell>{v.monthly}</Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                    </table>
                }
                
            }else{
                if(type === 'group'){
                    components = <table className='ui very basic large table'>
                    <Table.Body>
                        {leaderboard.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>
                                <Modal closeIcon size='small' trigger={<Button className='linked'>{v.group_name}</Button>}>
                                    <Modal.Header>{v.group_name}</Modal.Header>
                                    <Modal.Content>
                                        {v.member_details.length > 0 ? 
                                        <Table basic>
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Mayor Name</th>
                                                    <th>City Name</th>
                                                </tr>
                                            </thead>
                                            <Table.Header>
                                                {v.member_details.map((x, y)=>
                                                <Table.Row key={y}>
                                                    <Table.Cell>{y+1}</Table.Cell>
                                                    <Table.Cell>{x.Mayor_Name}</Table.Cell>
                                                    <Table.Cell>{x.City_Name}</Table.Cell>
                                                </Table.Row>
                                                )}
                                            </Table.Header>
                                        </Table>
                                        :<Header as="h2">No Member Found...</Header>}
                                    </Modal.Content>
                                </Modal>
                            </Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>
                }else{
                    components = <table className='ui very basic large table'>
                    <Table.Body>
                        {leaderboard.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>
                                <Modal closeIcon size='small' trigger={<Button className='linked'>{v.alliance_name}</Button>}>
                                    <Modal.Header>{v.alliance_name}</Modal.Header>
                                    <Modal.Content>
                                        {v.member_details.length > 0 ? 
                                        <Table basic>
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Mayor Name</th>
                                                    <th>City Name</th>
                                                </tr>
                                            </thead>
                                            <Table.Header>
                                                {v.member_details.map((x, y)=>
                                                <Table.Row key={y}>
                                                    <Table.Cell>{y+1}</Table.Cell>
                                                    <Table.Cell>{x.Mayor_Name}</Table.Cell>
                                                    <Table.Cell>{x.City_Name}</Table.Cell>
                                                </Table.Row>
                                                )}
                                            </Table.Header>
                                        </Table>
                                        :<Header as="h2">No Member Found...</Header>}
                                    </Modal.Content>
                                </Modal>
                            </Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>
                }
            }
            
        }else{
            if(is_mission){
                components = <table className="ui celled structured table">
                <thead>
                  <tr>
                    <th rowSpan="2">Rank</th>
                    <th rowSpan="2">Name</th>
                    <th colSpan="3" className="center aligned">Mission Completed</th>
                  </tr>
                  <tr>
                    <th>Daily</th>
                    <th>Weekly</th>
                    <th>Monthly</th>
                  </tr>
                </thead>
                <Table.Body>
                    {leaderboard.map((v, k)=>
                    <Table.Row key={k}>
                        <Table.Cell>{k+1}</Table.Cell>
                        <Table.Cell>{v.mayor_name} ({v.city_name})</Table.Cell>
                        <Table.Cell>{v.daily}</Table.Cell>
                        <Table.Cell>{v.weekly}</Table.Cell>
                        <Table.Cell>{v.monthly}</Table.Cell>
                    </Table.Row>
                    )}
                </Table.Body>
                </table>
            }else{
                components = <table className='ui very basic large table'>
                    <Table.Body>
                        {leaderboard.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.mayor_name} ({v.city_name})</Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>
            }
            
        }
        return components
    }

    const generateImprovementTable = () =>{
        if(improvement.length === 0){
            return <Header as="h2">No data found...</Header>
        }

        return(
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>No.</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Diagnostic result</Table.HeaderCell>
                        <Table.HeaderCell>Current level</Table.HeaderCell>
                        <Table.HeaderCell>CEFR improvement?</Table.HeaderCell>
                        <Table.HeaderCell>Number of levels improved</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {improvement.map((v, k)=>
                    <Table.Row key={k}>
                        <Table.Cell>{k+1}</Table.Cell>
                        <Table.Cell>{v.Chat_Name} ({v.User_Name})</Table.Cell>
                        <Table.Cell>{v.diag_cefr}</Table.Cell>
                        <Table.Cell>{v.current_cefr}</Table.Cell>
                        <Table.Cell>{v.current_score - v.diag_score > 0 ? 'Yes' : 'No'}</Table.Cell>
                        <Table.Cell>{v.current_score - v.diag_score}</Table.Cell>
                    </Table.Row>    
                    )}
                </Table.Body>
            </Table>
        )
    }

    const generateSummary = () =>{
        let wordNumber = partnerData.Leaderboard_Type.includes('Star') ? 'star(s)' : ''

        if(summary.length === 0){
            return <Header as="h2">No player reached the minimum requirement yet!</Header>
        }

        let components = null
        let type = partnerData.Leaderboard_Type.split(',')[0]
        switch (type) {
            case 'Learnalytics Group':
                components = <table className='ui very basic large table'>
                    <Table.Body>
                        {summary.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.group_name}</Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>
                break;
            case 'Individual':
                components = <table className='ui very basic large table'>
                    <Table.Body>
                        {summary.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.mayor_name} ({v.city_name})</Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>       
                break;
            default: //alliance
                components = <table className='ui very basic large table'>
                    <Table.Body>
                        {summary.map((v, k)=>
                        <Table.Row key={k}>
                            <Table.Cell>{k+1}</Table.Cell>
                            <Table.Cell>{v.alliance_name}</Table.Cell>
                            <Table.Cell>{v.points} <sub>{wordNumber}</sub></Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </table>       
                break;
        }

        return components
    }

    const generateContent = () =>{
        let lType = partnerData.Leaderboard_Type.split(',')
        let leaderboardType = lType[0]
        let leaderboardSubType = lType[1]
        let sections = partnerData.Sections.split(',')
        let result = []
        let isMission = leaderboardSubType.toLowerCase().includes('mission') ? true : false
        let contentType = leaderboardType === 'Learnalytics Group' ? 'group' : leaderboardType === 'Alliance' ? 'alliance' : 'individual'
        if(leaderboardType === 'Learnalytics Group'){}


        if(leaderboard.length > 0){
            sections.forEach(x=>{
                if(x === 'leaderboard'){
                    result.push(generateLeaderboard(isMission, contentType))
                }
            })
        }else{
            result.push(<Header as="h2">No Data Found...</Header>)
        }

        return result
    }

    const generateRules = () =>{
        let rules = partnerData.Rules.split(';')
        let comps = <List>
            {rules.map((v, k)=>
            <List.Item key={k}>{v}</List.Item>
            )}
        </List>
        
        return comps
    }

    return(
        <div className='partnerContainer'>
            {partnerData === null ? <Loader active/> :
                <Container>
                    <Segment>
                        <Grid columns={'equal'}>
                            <Grid.Column width={10}>
                                <Header as="h1">
                                    <Icon name='trophy' color='orange'/> {partnerData.Title}
                                </Header>
                                <Message info>
                                    {partnerData.Information_Text}
                                </Message>
                                <Modal size='small' trigger={<Button primary size='small'>Rules!</Button>} closeIcon>
                                    <Modal.Header>Rules!</Modal.Header>
                                    <Modal.Content scrolling>
                                        <Message info>
                                        {generateRules()}
                                        </Message>
                                    </Modal.Content>
                                </Modal>
                                <Divider hidden/>
                                {partnerData.Sections.includes('video')? 
                                <>
                                <Header as="h2" color='orange'>{partnerData.Video.title}</Header>
                                <iframe title="doc" width="100%" height="315" src={partnerData.Video.url}
                                frameBorder="0" allowFullScreen>
                                </iframe>
                                </>
                                : null}
                            </Grid.Column>
                            <Grid.Column>
                                {partnerData.Logo !== null ? <Image src={partnerData.Logo} size="small" floated='right'/> : null}
                            </Grid.Column>
                        </Grid>

                        {partnerData.Sections.includes('summary') ? 
                        <>
                        <Divider hidden/>
                        {loading ? <Dimmer active><Loader active size='large' content='Fetching Data...'/></Dimmer> : generateSummary()}
                        </>
                        : null}
                    </Segment>
                    
                    {partnerData.Sections.includes('leaderboard') ? 
                    <Segment>
                        <Header as="h1">All Leaderboard</Header>
                        {loading ? <Dimmer active><Loader active size='large' content='Fetching Data...'/></Dimmer> : generateContent().map((v, k)=>{
                            return <div key={k}>{v}</div>
                        })}
                    </Segment>
                    : null}
                    
                    {partnerData.Sections.includes('improvement') ? 
                    <Segment>
                        <Header as="h1">Table Improvement</Header>
                        {loading ? <Dimmer active><Loader active size='large' content='Fetching Data...'/></Dimmer> : generateImprovementTable()}
                    </Segment>
                    : null}
                </Container>
            }
        </div>
    )
}

export default PartnerDetailPage

